export default {
  root: ({ instance, props }) => ({
    class: [
      // Sizing and Shape
      'rounded-md',
      { 'w-fit max-h-60 overflow-auto': instance.$props['popup'] },
      { 'w-48 3xl:w-56 4xl:w-72': !instance.$props['popup'] },
      { 'w-24': instance.$attrs['context-menu'] },
      // Spacing
      { 'py-2 shadow-2xl': instance.$props['popup'] },
      { 'py-6': !instance.$props['popup'] },
      { 'py-3': instance.$attrs['context-menu'] },
      // Colors
      { 'bg-white text-black': !instance.$attrs['transparent'] },
      { 'bg-none text-white': instance.$attrs['transparent'] },
      { 'px-2': props.popup },
    ],
  }),
  menu: ({ instance }) => ({
    class: [
      // Spacings and Shape
      'list-none',
      'mx-auto',
      'outline-none',
      { 'px-0': instance.$attrs['nav-menu'] || instance.$attrs['orgs'] },
      { 'px-3': !instance.$attrs['nav-menu'] && !instance.$attrs['orgs'] },
    ],
  }),
  itemContent: ({ parent, context }) => ({
    class: [
      'pt-2 px-2 rounded-sm',
      {
        'hover:bg-blue-50': !parent.instance.$attrs['nav-menu'] && !context.item.disabled,
      },
      { 'opacity-50 cursor-not-allowed': context.item.disabled },
    ],
  }),
  action: ({ parent, context }) => ({
    class: [
      'relative',
      // Flexbox

      'flex',
      'items-center',

      // Spacing
      {
        'py-2.5': parent.instance.$attrs['account-menu'] || parent.instance.$attrs['context-menu'],
      },
      {
        'py-3 px-2':
          !parent.instance.$attrs['account-menu'] && !parent.instance.$attrs['context-menu'],
      },

      // Color
      { 'text-black text-sm font-medium': !parent.instance.$attrs['transparent'] },
      { 'text-white': parent.instance.$attrs['transparent'] },

      // Misc
      'no-underline',
      'overflow-hidden',
      'select-none',
      {
        'cursor-pointer': !context.item.disabled,
        'cursor-not-allowed opacity-50': context.item.disabled,
      },
    ],
  }),
  itemLink: ({ parent, context }) => ({
    class: [
      'relative',
      // Flexbox

      'flex',
      'items-center',

      {
        'hover:bg-blue-50': !parent.instance.$attrs['nav-menu'] && !context.item.disabled,
      },

      // Spacing
      'py-2',
      'px-2',

      // Shape
      'rounded-md',

      // Misc
      'no-underline',
      'overflow-hidden',
      'select-none',
      {
        'cursor-pointer': !context.item.disabled,
        'cursor-not-allowed opacity-50': context.item.disabled,
      },
    ],
  }),
  itemIcon: {
    class: [
      // Spacing
      'mr-2',

      // Color
      'text-surface-600',
    ],
  },
  itemLabel: {
    class: ['leading-[normal]'],
  },
  submenuLabel: {
    class: [
      // Font
      'font-bold',

      // Spacing
      'm-0',
      'py-2 px-3',

      // Shape
      'rounded-tl-none',
      'rounded-tr-none',

      // Colors
      'bg-surface-0',
      'text-surface-400',
    ],
  },
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass: 'transition-[transform,opacity] duration-120 ease-out',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0',
  },
};
